module.exports = __webpack_public_path__ + "static/media/icon-university.50c6d9f9.svg";